<template>
  <div>
    <div class="navbar-overlay" v-if="dialog"></div>
    <NavBar></NavBar>
    <div class="relative scroll-smooth">
      <div :class="sidebarOpen ? 'lg:pl-60 relative' : 'md:p-0'">
        <SideBarMobile class="block md:hidden" />
        <SideBar class="hidden md:block" />
        <div
          class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
          role="alert"
          v-if="alert"
        >
          <span class="block sm:inline">{{ display }}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
            <svg
              @click="alert = false"
              class="fill-current h-6 w-6 text-red-500"
              role="button"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <title v-if="!alert">Close</title>
              <path
                d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
              />
            </svg>
          </span>
        </div>
        <router-view :key="$route.fullPath" />

        <div
          v-if="dialog"
          class="absolute top-0 p-4 sidebar-overlay inset-0 flex items-center justify-center bg-gray-700 bg-opacity-50"
          style="position: fixed"
        >
          <div class="rounded-md">
            <div class="flex items-center justify-between">
              <div class="shadow-xl">
                <a
                  href="#"
                  class="block max-w-xl p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
                >
                  <h4
                    class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white"
                  >
                    Confirmation!
                  </h4>
                  <p class="font-normal text-gray-700 dark:text-gray-400">
                    In accordance with Regulatory compliance regarding your
                    latest annual income range, you are requested to update the
                    same by selecting one option out of available income ranges.
                  </p>
                  <div class="flex flex-wrap gap-3 mt-2">
                    <div
                      v-for="option in radioOptions"
                      :key="option.id"
                      class="flex items-center mb-4"
                    >
                      <input
                        :id="option.id"
                        type="radio"
                        :value="option.value"
                        v-model="incomeCategory"
                        name="default-radio"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600"
                      />
                      <label
                        :for="option.id"
                        class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        {{ option.label }}
                      </label>
                    </div>
                  </div>
                  <div class="flex justify-center">
                    <button
                      v-if="showContinueButton"
                      @click="SubmitIncomeCategory('continue')"
                      type="button"
                      class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    >
                      Continue with existing
                    </button>
                    <button
                      @click="SubmitIncomeCategory('normal')"
                      :disabled="incomeCategory == ''"
                      :class="{
                        'bg-gray-400 dark:bg-gray-400': incomeCategory === '',
                        'cursor-not-allowed': incomeCategory === '',
                      }"
                      type="button"
                      class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    >
                      Submit
                    </button>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="nomineeDialog"
          class="absolute top-0 p-4 sidebar-overlay inset-0 flex items-center justify-center bg-gray-700 bg-opacity-50"
          style="position: fixed"
        >
          <div class="rounded-md">
            <div class="flex items-center justify-between">
              <div class="shadow-xl">
                <a
                  href="#"
                  class="block max-w-xl p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
                >
                  <h4
                    class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white"
                  >
                    Action Required!
                  </h4>
                  <p class="font-normal text-gray-700 dark:text-gray-400">
                    You have not added a nominee to your account yet. Adding a
                    nominee helps protect your investments and is required as
                    per regulatory guidelines.<br />
                    Please take a moment to update your nominee details.
                  </p>
                  <!-- Loader -->
                  <div v-if="popupOverlay" class="flex justify-center my-3">
                    <div class="lds-dual-ring"></div>
                  </div>
                  <div class="flex justify-center gap-3 mt-2">
                    <button
                      @click="nomineeDialog = false"
                      type="button"
                      class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    >
                      Skip for Now
                    </button>
                    <button
                      @click="redirectNomineePage"
                      type="button"
                      class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    >
                      Update Nominee
                    </button>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  toRefs,
  computed,
  onMounted,
  watch,
  defineComponent,
} from "vue";
import apiClient from "./config/axios";
import { useUserStore } from "./store/user";
import SideBar from "./components/SideBar.vue";
import NavBar from "./components/NavBar.vue";
import router from "./router";
import { useCommonStore } from "@/store/commonStore";
import SideBarMobile from "./components/SideBarMobile.vue";
export default defineComponent({
  components: { SideBar, NavBar, SideBarMobile },
  setup() {
    const commonStore = useCommonStore();
    const userStore = useUserStore();
    const state = reactive({
      alert: false,
      boid: 0,
      dpid: 0,
      onIncomeDialogClose: null,
      popupOverlay: false,
      nomineeDialog: false,
      showContinueButton: false,
      mainTitle: "Definedge Securities Dashboard",
      url: process.env.VUE_APP_URL,
      cards: ["Today", "Yesterday"],
      drawer: true,
      dialog: false,
      radioOptions: [
        { id: "default-radio-1", value: "below-1L", label: "Below 1 Lakh" },
        { id: "default-radio-2", value: "1-5L", label: "1L - 5L" },
        { id: "default-radio-2", value: "5L-10L", label: "5L - 10L" },
        { id: "default-radio-2", value: "10L-25L", label: "10L - 25L" },
        { id: "default-radio-2", value: "above-25L", label: "Above 25L" },
      ],
      display: "",
      incomeCategory: "",
      completedOffersObj: "",
      // offersButton: false,
      // offersList: [],
      // buttonname: "",
      // description: "",
      // schemecode: "",
      selectedItem: 0,
      link: "",
      navbarOpen: computed(() => commonStore.getNavbar),
      sidebarOpen: computed(() => commonStore.getSidebar),
      phone: computed(() => userStore.username.phone),
      firstname: computed(() => userStore.username.firstname),
      lastname: computed(() => userStore.username.lastname),
      email: computed(() => userStore.username.email),
      ucc: computed(() => userStore.username.ucc),
      role: computed(() => userStore.username.role),
      totp: computed(() => userStore.username.totp),
      userName: computed(() => userStore.getUserName),
      km: computed(() => userStore.username?.km || null),
      showAffiliate: computed(() => {
        return userStore?.getUserName.role.includes("DEFINEDGE_AFFILIATE");
      }),
      showSupport: computed(() => {
        return userStore?.getUserName.role.includes("DEF_SUPPORT_MEM");
      }),
      showReferral: computed(() => {
        return !userStore?.getUserName.role.includes("DEFINEDGE_AFFILIATE");
      }),
      showFreeSubscription: computed(() => {
        return !state.completedOffersObj;
      }),
      initials: computed(() => {
        console.log("user is : ", userStore?.username);
        const fullnameArray = userStore?.username.firstname.split(" ");
        console.log("initial letter : ", fullnameArray?.[0]?.split("")[0]);
        const firstchar = fullnameArray[0]?.split("")[0];
        const secondchar = fullnameArray[1]?.split("")[0];
        const finalchar = firstchar + secondchar;
        console.log("initial letter final : ", finalchar);
        return finalchar;
      }),
      getIdByItem: computed(() => (title) => {
        if (title === "Reports") {
          return "reports";
        } else if (title === "Funds") {
          return "funds";
        } else if (title === "Affiliate Home") {
          return title;
        }
        return "";
      }),
      toolbar: false,
      admin: computed(() => {
        return userStore.admin;
      }),
      user: computed(() => {
        return userStore.getUser;
      }),
      userdata: computed(() => {
        return userStore.userdata;
      }),
      payadmin: computed(() => {
        debugger;
        return userStore.payadmin;
      }),
      finadmin: computed(() => {
        return userStore.finadmin;
      }),
      aradmin: computed(() => {
        return userStore.aradmin;
      }),
    });
    onMounted(async () => {
      console.log("sidebarOpen", state.sidebarOpen);
      // debugger;
      onLoad();
      if (window.location.pathname.match("/affiliate")) {
        state.mainTitle = "Affiliate Dashboard";
      }
      if (!userStore.getUser) {
        console.log("Created fun in app.vue if block");
        state.drawer = false;
        state.toolbar = false;
        changeTheme();
      }
      // else if (this.status != null) {
      //   debugger;
      //   vuetify.theme.dark;
      //   this.drawer = false;
      //   this.toolbar = true;
      // }
      else if (state.ucc == null) {
        console.log("mobile number empty and in app.vye else if block");
        state.drawer = false;
        state.toolbar = false;
        //state.changeTheme()
      } else {
        console.log("MOBILE number NOT EMPTY and in app.vye else block");
        state.drawer = true;
        state.toolbar = true;
      }
      // this.getOngoingOffers(),
      getCompletedOffers();
      var resp = await checkDormantUser();
      console.log("resp :", resp);
      if (!resp) {
        await getIncomeCategory();
      }
      console.log("After if condition ");
      getNomineeDetails();
      setInterval(() => {
        // state.alert = false;
        // state.successalert = false;
      }, 10000);
    });

    function timeInterval() {
      setTimeout(() => {
        state.alert = false;
      }, 10000);
    }

    const getNomineeDetails = () => {
      apiClient
        .get("rekycrequest/getNomineeDetails")
        .then((response) => {
          // debugger;
          if (response.status == 200) {
            debugger;
            console.log("Nominee Data : ", response.data);
            if (response.data != null && response.data?.length == 0) {
              console.log(
                "Nominee Data condition true: ",
                response.data?.length
              );
              state.nomineeDialog = true;
            } else state.nomineeDialog = false;
            console.log(
              "Nominee Data condition false: ",
              response.data?.length
            );
          }
        })
        .catch((error) => {
          console.log("Error getting nominee details in App.vue :", error);
          state.nomineeDialog = false;
        });
    };

    const checkDormantUser = async () => {
      console.log("checkDormantUser");
      try {
        const response = await apiClient.get(`/dormant/checkdormantUser`);
        console.log("response from checkdormantUser", response.data);

        // if (response.data > 730) {
        //   console.log("Dormant: 2 years");
        //   return true;
        // } else if (response.data > 365 && response.data <= 730) {
        //   console.log("Dormant: 1 year");
        //   return true;
        // }
        if (
          response.data != null &&
          response.data != "" &&
          response.data == 1
        ) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.log("Error while checking dormant details", error);
        return false;
      }
    };

    const onLoad = () => {
      debugger;
      // console.log('join related data :',window.location.search)
      if (window.location.pathname.match("/join")) {
        console.log("Without authentication pass url");
        userStore.Name({ role: ["joinlead"] });
        router.push(window.location.pathname);
      } else if (window.location.pathname.match("/payu-response")) {
        console.log("payu-response-success");
        userStore.Name({ role: ["joinlead"] });
        router.push("/payu-response");
      } else if (window.location.pathname.match("/fail-payu-response")) {
        console.log("payu-response-fail");
        userStore.Name({ role: ["joinlead"] });
        router.push("/fail-payu-response");
      } else if (window.location.pathname.match("/pledgeSuccess-response")) {
        console.log("pledgeSuccess-response");
        userStore.Name({ role: ["joinlead"] });
        router.push("/pledgeSuccess-response");
      } else if (window.location.pathname.match("/pledgeFail-response")) {
        console.log("pledgeFail-response");
        userStore.Name({ role: ["joinlead"] });
        router.push("/pledgeFail-response");
      } else if (window.location.pathname.match("/pledgePartial-response")) {
        console.log("pledgePartial-response");
        userStore.Name({ role: ["joinlead"] });
        router.push("/pledgePartial-response");
      } else if (window.location.pathname.match("/unpledgeSuccess-response")) {
        // debugger;
        console.log("unpledgeSuccess-response");
        userStore.Name({ role: ["joinlead"] });
        router.push("/unpledgeSuccess-response");
      } else if (window.location.pathname.match("/esignSuccess")) {
        userStore.Name({ role: ["joinlead"] });
        router.push("/esignSuccess");
      } else if (window.location.pathname.match("/esignFailed")) {
        userStore.Name({ role: ["joinlead"] });
        router.push("/esignFailed");
      } else if (window.location.pathname.match("/otsConfirmation")) {
        debugger;
        const searchParams = new URLSearchParams(window.location.search);
        const queryParamValue = searchParams.get("data");
        // Dispatch action with the query parameter value
        userStore.Name({ role: ["joinlead"] });

        // Redirect to "otsConfirmation" component
        router.push({
          name: "otsConfirmation",
          params: {
            otsResponse: queryParamValue,
          },
        });
      } else {
        var diffpathname = "";
        console.log("Path name : ", window.location.pathname);
        if (window.location.pathname != null) {
          diffpathname = window.location.pathname;
        }
        console.log("action : ", diffpathname);
        apiClient
          .get("session/")
          .then((response) => {
            debugger;
            console.log("MAIN PAGE");
            console.log(response);
            if (response.status == 401) {
              //change here
              window.location.assign("/ssologin" + diffpathname);
              //window.location.href('http://localhost8081/ssologin')
            } else {
              debugger;
              console.log(
                "username :",
                response.data.userName,
                "phone number :",
                response.data.phone,
                ", role :",
                response.data.userrole,
                " phone number :",
                response.data.phone
              );
              userStore.autoLogin(response.data); //change here
              userStore.Name({
                firstname: response.data.firstname,
                lastname: response.data.lastname,
                email: response.data.email,
                role: response.data.userrole,
                phone: response.data.phone,
                ucc: response.data.ucc,
                totp: response.data.totp,
                km: response.data?.km || null,
              });
              if (window.location.pathname.match("/holdings")) {
                // router.push("/holdings");
                const passParams = {
                  status: "createPledge",
                };
                router.push({ name: "holdings", params: passParams });
              } else if (window.location.pathname.match("/payIn")) {
                router.push("/payIn");
              } else if (window.location.pathname.match("/payout")) {
                router.push("/payout");
              } else if (window.location.pathname.match("/trade-register")) {
                router.push("/trade-register");
              } else if (
                window.location.pathname.match("/FNO-trade-register")
              ) {
                router.push("/FNO-trade-register");
              } else if (window.location.pathname.match("/ledger")) {
                router.push("/ledger");
              } else if (window.location.pathname.match("/margin-client")) {
                router.push("/margin-client");
              } else if (window.location.pathname.match("/digital-contract")) {
                router.push("/digital-contract");
              } else if (window.location.pathname.match("/realized-P&L")) {
                router.push("/realized-P&L");
              } else if (window.location.pathname.match("/unrealized-P&L")) {
                router.push("/unrealized-P&L");
              } else if (window.location.pathname.match("/open-position")) {
                router.push("/open-position");
              } else if (window.location.pathname.match("/daily-bill")) {
                router.push("/daily-bill");
              } else if (window.location.pathname.match("/collateral")) {
                router.push("/collateral");
              } else if (window.location.pathname.match("/mydetails")) {
                router.push("/mydetails");
              } else if (window.location.pathname.match("/buy-product")) {
                router.push("/buy-product");
              } else if (window.location.pathname.match("/referral-home")) {
                console.log("Redirect referral:");
                router.push("/referral-home");
              } else if (window.location.pathname.match("/feedback")) {
                router.push("/feedback");
              } else if (window.location.pathname.match("/request")) {
                router.push("/request");
              } else if (
                window.location.pathname.match("/historyOfPayinPayout")
              ) {
                router.push("/historyOfPayinPayout");
              } else if (window.location.pathname.match("/wallet")) {
                router.push("/wallet");
              } else if (window.location.pathname.match("/sarathi-score")) {
                router.push("/sarathi-score");
              } else if (window.location.pathname.match("/payment-history")) {
                router.push("/payment-history");
              } else if (window.location.pathname.match("/subscriptions")) {
                router.push("/subscriptions");
              } else if (window.location.pathname.match("/affiliate")) {
                router.push("/affiliate");
              } else if (window.location.pathname.match("/fund-reallocation")) {
                router.push("/fund-reallocation");
              } else if (
                window.location.pathname.match("/segment-allocation")
              ) {
                router.push("/segment-allocation");
              } else if (window.location.pathname.match("/journal")) {
                router.push("/journal");
              } else if (window.location.pathname.match("/freeSubscription")) {
                router.push("/freeSubscription");
              } else if (window.location.pathname.match("/tax-P&L")) {
                router.push("/tax-P&L");
              } else if (window.location.pathname.match("/customer-search")) {
                router.push("/customer-search");
              } else if (window.location.pathname.match("/discount-master")) {
                router.push("/discount-master");
              } else if (window.location.pathname.match("/product-master")) {
                router.push("/product-master");
              } else if (window.location.pathname.match("/customer-payments")) {
                router.push("/customer-payments");
              } else if (window.location.pathname.match("/customer-subs")) {
                router.push("/customer-subs");
              } else if (window.location.pathname.match("/customer-invoice")) {
                router.push("/customer-invoice");
              } else if (window.location.pathname.match("/finance-payin")) {
                router.push("/finance-payin");
              } else if (window.location.pathname.match("/exchange-info")) {
                router.push("/exchange-info");
              } else if (window.location.pathname.match("/finance-payout")) {
                router.push("/finance-payout");
              } else if (window.location.pathname.match("/finance-wallet")) {
                router.push("/finance-wallet");
              } else if (window.location.pathname.match("/admAffiliate")) {
                router.push("/admAffiliate");
              } else if (window.location.pathname.match("/admReferral")) {
                router.push("/admReferral");
              } else if (window.location.pathname.match("/manage-affiliate")) {
                router.push("/manage-affiliate");
              } else if (
                window.location.pathname.match("/customer-payin-payout")
              ) {
                router.push("/customer-payin-payout");
              } else if (window.location.pathname.match("/support-wallet")) {
                router.push("/support-wallet");
              } else if (
                window.location.pathname.match("/suspended-affiliate")
              ) {
                router.push("/suspended-affiliate");
              } else if (
                window.location.pathname.match("/manage-reallocation")
              ) {
                router.push("/manage-reallocation");
              } else if (
                window.location.pathname.match("/feedbackConfirmation")
              ) {
                router.push("/feedbackConfirmation");
              } else {
                router.push("/");
              }
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response?.status == 401) {
              //change here
              window.location.assign("/ssologin" + diffpathname);
            } else {
              window.alert("Error Connecting Server:" + error);
            }
          });
      }
    };

    const htmlElement = document.getElementById("parentHtml");
    commonStore.isDark = htmlElement.classList.contains("dark");
    htmlElement.addEventListener("click", () => {
      commonStore.isDark = htmlElement.classList.contains("dark");
    });
    const SubmitIncomeCategory = (element) => {
      debugger;
      console.log("submit income category : ", element);
      if (element === "continue") {
        state.incomeCategory = "continue";
      }
      apiClient
        .get(`user/saveClientIncomeCategory/${state.incomeCategory}`)
        .then((response) => {
          // debugger;
          if (response.status == 200) {
            // debugger;
            console.log("Response is :", response);
            state.dialog = false;
            // IMPORTANT: resume onMounted flow
            if (state.onIncomeDialogClose) {
              state.onIncomeDialogClose();
              state.onIncomeDialogClose = null;
            }
          }
        })
        .catch((error) => {
          console.log(error);
          // still allow flow to continue
          if (state.onIncomeDialogClose) {
            state.onIncomeDialogClose();
            state.onIncomeDialogClose = null;
          }
        });
    };
    const getCompletedOffers = () => {
      apiClient
        .get("userproductDetails/getofferscompleteddata")
        .then((response) => {
          // debugger;
          if (response.status == 200) {
            // debugger;
            state.completedOffersObj = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    // const getIncomeCategory = async () => {
    //   apiClient
    //     .get("user/getIncomeCategory")
    //     .then((response) => {
    //       // debugger;
    //       if (response.status == 200) {
    //         debugger;
    //         const responseMsg = response.data;
    //         if (responseMsg === 0) {
    //           state.dialog = true;
    //         } else if (responseMsg >= 1) {
    //           state.dialog = true;
    //           state.showContinueButton = true;
    //         } else state.dialog = false;
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // };
    const getIncomeCategory = () => {
      return new Promise((resolve) => {
        apiClient
          .get("user/getIncomeCategory")
          .then((response) => {
            if (response.status === 200) {
              const responseMsg = response.data;

              if (responseMsg === 0) {
                state.dialog = true;
                state.showContinueButton = false;
              } else if (responseMsg >= 1) {
                state.dialog = true;
                state.showContinueButton = true;
              } else {
                state.dialog = false;
                resolve(); // no popup, continue flow
              }

              // store resolver to call later
              state.onIncomeDialogClose = resolve;
            }
          })
          .catch((error) => {
            console.log(error);
            resolve(); // allow app to continue even on error
          });
      });
    };

    const onLogout = () => {
      window.location.assign("/logout");
    };
    const login = () => {
      window.location.assign("/ssologin");
    };
    const changeTheme = () => {
      // vuetify.theme.dark = !vuetify.theme.dark;
    };
    const sublinkfunction = (id) => {
      if (id === "Affiliate Home") {
        state.mainTitle = "Affiliate Dashboard";
      } else {
        state.mainTitle = "Definedge Securities Dashboard";
      }
      const linkIds = ["reports", "funds"];
      linkIds.forEach((linkId) => {
        const linkElement = document.getElementById(linkId);
        if (id == linkId) {
          linkElement.classList.add("v-list-item--active");
        } else {
          linkElement.classList.remove("v-list-item--active");
        }
      });
    };

    async function getDematDetails() {
      const passdata = {
        reportname: "Client Demtat Ac",
      };
      return apiClient
        .post("backoffice/searchDematDetails", passdata)
        .then((response) => {
          if (response.status == 200) {
            state.dematdetails = response.data;
            console.log("dematdetails---", state.dematdetails);
            state.dpid = state.dematdetails[0].dpid;
            state.boid = state.dematdetails[0].boid;
          } else {
            console.log("Error: " + response.status);
          }
          state.overlay = false;
        })
        .catch((error) => {
          console.log("Error while getting demat details", error);
        });
    }

    function redirectNomineePage() {
      state.popupOverlay = true;
      return apiClient
        .get("rekycrequest/checkHoliday")
        .then(async (response) => {
          console.log("checkHoliday response :", response);
          if (response.status == 200) {
            debugger;
            console.log("checkHoliday response data :", response.data);
            if (response.data == true) {
              state.alert = true;
              state.display =
                "Your previous request is under process and the changes will be reflected in your demat account by next working day";
              timeInterval();
            } else {
              await getDematDetails();
              state.nomineeDialog = false;
              state.popupOverlay = false;
              console.log("state.dpid :", state.dpid);
              userStore.dematDetails = state.dpid;
              userStore.boid = state.boid;
              router.push("/nominee");
            }
          } else {
            console.log("Error: " + response.status);
          }
          state.nomineeDialog = false;
          state.popupOverlay = false;
        })
        .catch((error) => {
          console.log(error);
          state.alert = true;
          state.display =
            "Something went wrong..Please try again after some time.";
          state.popupOverlay = false;
          timeInterval();
        });
    }

    watch(
      () => state.userName?.phone,
      () => {
        if (state.userName?.phone == null) {
          commonStore.hideNavSidebar();
        } else {
          commonStore.showNavSidebar();
        }
      },
      { immediate: true }
    );
    watch(
      () => state.toolbar,
      () => {
        state.drawer = true;
      },
      { immediate: true }
    );

    return {
      ...toRefs(state),
      SubmitIncomeCategory,
      onLogout,
      login,
      changeTheme,
      sublinkfunction,
      getIncomeCategory,
      getCompletedOffers,
      checkDormantUser,
      getNomineeDetails,
      redirectNomineePage,
      getDematDetails,
      timeInterval,
    };
  },
});
</script>
<style>
.sidebar-overlay {
  z-index: 1001; /* Make sure overlay is above other content */
}
.navbar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3); /* Semi-transparent overlay */
  pointer-events: auto; /* Enable pointer events on the overlay */
  z-index: 100; /* Place the overlay above the navbar */
}

.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #002d67;
  border-color: #002d67 transparent #002d67 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.relative {
  position: relative;
}
</style>
